import { LoadingButton } from '@mui/lab';
import type { ButtonProps } from '@mui/material';
import { Button, ButtonGroup } from '@mui/material';
import type { FC } from 'react';
import { useState } from 'react';

export const ConfirmButton: FC<ButtonProps & { busy: boolean }> = (props) => {
  const { busy, ...rest } = props;
  const [state, setState] = useState<'normal' | 'confirm'>('normal');

  if (state === 'normal') {
    return (
      <LoadingButton
        {...rest}
        loading={busy}
        onClick={() => setState('confirm')}
      />
    );
  }

  return (
    <ButtonGroup aria-label="confirm action" variant="outlined">
      <Button color="error" onClick={rest.onClick} variant="contained">
        Yes
      </Button>
      <Button onClick={() => setState('normal')}>No</Button>
    </ButtonGroup>
  );
};
